import { TOAST_ACTION } from '../feedback/feedbackConstants';

const PICKUP_NOTICE = 'pickup-notice';

/** Admin and seller mount the assignment screen at the same path. */
const GO_TO_ASSIGN = {
  label: 'Ir a asignar pedidos →',
  type: TOAST_ACTION.NAVIGATE,
  to: '/pickup-requests/assign',
};

/**
 * The toasts of the pickup requests. Errors stay in the screen's banner, which
 * shows the slice's `error` along with the failed loads. See `feedbackCatalog`
 * for what each field means.
 */
export const PICKUP_REQUESTS_FEEDBACK_RULES = {
  'pickupRequests/createPickupRequest': {
    success: ({ payload }) => ({
      message: `Solicitud ${payload.external_pickup_id} creada correctamente.`,
      action: GO_TO_ASSIGN,
    }),
    error: 'none',
    testId: PICKUP_NOTICE,
  },

  'pickupRequests/registerManualPickup': {
    success: ({ payload }) => ({
      message: `Retiro ${payload.external_pickup_id} registrado.`,
      action: GO_TO_ASSIGN,
    }),
    error: 'none',
    testId: PICKUP_NOTICE,
  },

  'pickupRequests/assignOrders': {
    success: ({ payload }) =>
      payload?.manifest_url
        ? 'Pedidos asignados. Manifiesto disponible.'
        : 'Pedidos asignados correctamente.',
    error: 'none',
    testId: PICKUP_NOTICE,
  },

  'pickupRequests/requestManifest': {
    success: 'Manifiesto generado correctamente.',
    error: 'none',
    testId: PICKUP_NOTICE,
  },
};
